
import React from 'react';
import { Box, useTheme } from '@mui/material';


const SatisfyingRingsSvg = () => {
    const theme = useTheme();
    return (
        <svg width="200" height="200" viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
            <g>
                <circle cx="100" cy="100" r="40" stroke={theme.palette.primary.main} strokeWidth="10" fill="none">
                    <animate
                        attributeName="stroke-dasharray"
                        from="0, 251.2"
                        to="251.2, 0"
                        dur="2s"
                        repeatCount="indefinite"
                        keyTimes="0; 0.5; 1"
                        values="0, 251.2; 251.2, 251.2; 251.2, 0"
                    />
                    <animateTransform
                        attributeName="transform"
                        type="rotate"
                        from="0 100 100"
                        to="360 100 100"
                        dur="4s"
                        repeatCount="indefinite"
                    />
                </circle>
                <circle cx="100" cy="100" r="60" stroke={theme.palette.secondary.main} strokeWidth="10" fill="none">
                    <animate
                        attributeName="stroke-dasharray"
                        from="0, 376.8"
                        to="376.8, 0"
                        dur="2s"
                        repeatCount="indefinite"
                        keyTimes="0; 0.5; 1"
                        values="0, 376.8; 376.8, 376.8; 376.8, 0"
                    />
                    <animateTransform
                        attributeName="transform"
                        type="rotate"
                        from="360 100 100"
                        to="0 100 100"
                        dur="4s"
                        repeatCount="indefinite"
                    />
                </circle>
                <text x="50%" y="95%" textAnchor="middle"  fill={theme.palette.text.primary} fontSize="20">
                    Loading...
                </text>
            </g>
        </svg>
    );
};

const LoadingPage = () => {
    const theme = useTheme();
    return (
        <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            minHeight="80vh"
            bgcolor={theme.palette.background.default}
        >
            {/* <CircularProgress size={100} thickness={4} style={{ color: '#ff6347' }} /> */}
            <Box mt={4}>
                <SatisfyingRingsSvg />
            </Box>
            {/* <Typography variant="h5" color="textSecondary" style={{ marginTop: 20 }}>
                Loading...
            </Typography> */}
        </Box>
    );
};

export default LoadingPage;